(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neurd-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialogs = new WeakMap();
    const productObservers = new WeakMap();
    const menuObservers = new WeakMap();
    const focusable = root => [...root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):enabled, select:enabled, textarea:enabled, summary, [tabindex]:not([tabindex="-1"])')].filter(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]'));

    function setupDialog(dialog) {
      if (dialogs.has(dialog)) return;
      const section = dialog.closest('[id^="shopify-section-"]');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-label', section?.querySelector('.main-product__title')?.textContent.trim() || document.title);
      dialog.tabIndex = -1;
      let wasOpen = false;
      let returnFocus;
      let inertSiblings = [];
      const update = () => {
        const isOpen = dialog.classList.contains('pdp-lightbox--open');
        dialog.inert = !isOpen;
        dialog.setAttribute('aria-hidden', String(!isOpen));
        if (isOpen && !wasOpen) {
          returnFocus = document.activeElement;
          dialog.focus({ preventScroll: true });
          for (let branch = dialog; branch.parentElement && branch !== document.body; branch = branch.parentElement) {
            for (const sibling of branch.parentElement.children) {
              if (sibling !== branch && !sibling.inert && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
                sibling.inert = true;
                inertSiblings.push(sibling);
              }
            }
          }
          requestAnimationFrame(() => {
            if (dialog.classList.contains('pdp-lightbox--open')) (dialog.querySelector('.pdp-lightbox__close') || dialog).focus({ preventScroll: true });
          });
        } else if (!isOpen && wasOpen) {
          inertSiblings.forEach(element => { element.inert = false; });
          inertSiblings = [];
          if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
        }
        wasOpen = isOpen;
      };
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const items = focusable(dialog);
        const first = items[0] || dialog;
        const last = items[items.length - 1] || dialog;
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('transitionend', event => {
        if (event.target === dialog && dialog.classList.contains('pdp-lightbox--open') && !dialog.contains(document.activeElement)) {
          (dialog.querySelector('.pdp-lightbox__close') || dialog).focus({ preventScroll: true });
        }
      });
      const observer = new MutationObserver(update);
      observer.observe(dialog, { attributes: true, attributeFilter: ['class'] });
      dialogs.set(dialog, () => {
        observer.disconnect();
        inertSiblings.forEach(element => { element.inert = false; });
      });
      update();
    }

    function setupSubscriptions(root) {
      root.querySelectorAll('.appstle_sub_widget').forEach((widget, index) => {
        const baseId = widget.id || `neurd-purchase-options-${index}`;
        const title = widget.querySelector('.appstle_widget_title');
        const group = widget.querySelector('.appstle_subscription_wrapper');
        if (title && group) {
          title.id ||= `${baseId}-title`;
          title.setAttribute('role', 'heading');
          title.setAttribute('aria-level', '2');
          title.tabIndex = -1;
          group.setAttribute('role', 'radiogroup');
          group.setAttribute('aria-labelledby', title.id);
        }
        widget.querySelectorAll('input[type="radio"]').forEach(input => {
          const card = input.closest('.appstle_subscription_wrapper_option');
          if (!card || !input.id) return;
          const descriptions = [...card.querySelectorAll('.appstle_subscription_amount_wrapper, .appstle_one_time_price_wrapper, .appstleSellingPlanDescription')];
          descriptions.forEach((element, index) => { element.id ||= `${input.id}-details-${index}`; });
          const ids = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
          descriptions.forEach(element => ids.add(element.id));
          if (ids.size) input.setAttribute('aria-describedby', [...ids].join(' '));
        });
        const parent = widget.querySelector('.appstle-tootltip-parent');
        const trigger = parent?.querySelector('.appstle_tooltip_wrapper');
        const panel = parent?.querySelector('.appstle_tooltip');
        if (!trigger || !panel || trigger.dataset.neurdBound) return;
        trigger.dataset.neurdBound = 'true';
        trigger.tabIndex = 0;
        trigger.setAttribute('role', 'button');
        panel.id ||= `${baseId}-subscription-details`;
        trigger.setAttribute('aria-controls', panel.id);
        trigger.querySelectorAll('svg').forEach(svg => svg.setAttribute('aria-hidden', 'true'));
        const toggle = open => {
          parent.dataset.neurdTooltipOpen = String(open);
          trigger.setAttribute('aria-expanded', String(open));
        };
        trigger.addEventListener('click', () => toggle(parent.dataset.neurdTooltipOpen !== 'true'));
        trigger.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            trigger.click();
          }
        });
        parent.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            toggle(false);
            trigger.focus();
          }
        });
        parent.addEventListener('mouseenter', () => toggle(true));
        parent.addEventListener('mouseleave', () => { if (!parent.contains(document.activeElement)) toggle(false); });
        parent.addEventListener('focusout', event => { if (!parent.contains(event.relatedTarget)) toggle(false); });
        toggle(false);
      });
    }

    function setupMenu(panel) {
      if (menuObservers.has(panel)) return;
      const engine = panel.closest('toggletip-engine');
      const trigger = engine?.querySelector('[data-tooltip-trigger]');
      if (!trigger) return;
      let wasOpen = false;
      const update = () => {
        const open = trigger.getAttribute('aria-expanded') === 'true';
        panel.inert = !open;
        panel.setAttribute('aria-hidden', String(!open));
        if (open && !wasOpen) focusable(panel)[0]?.focus();
        if (!open && wasOpen && panel.contains(document.activeElement)) trigger.focus();
        wasOpen = open;
      };
      const keydown = event => {
        if (!wasOpen || event.key !== 'Tab') return;
        const items = [trigger, ...focusable(panel)];
        const index = items.indexOf(document.activeElement);
        event.preventDefault();
        items[(index + (event.shiftKey ? -1 : 1) + items.length) % items.length].focus();
      };
      engine.addEventListener('keydown', keydown);
      const observer = new MutationObserver(update);
      observer.observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
      menuObservers.set(panel, observer);
      update();
    }

    function initialize(root = document) {
      root.querySelectorAll('.pdp-lightbox').forEach(setupDialog);
      root.querySelectorAll('.nav--mobile[data-tooltip]').forEach(setupMenu);
      if (!document.body.classList.contains('template-product-dream-weaver-powder')) return;
      root.querySelectorAll('.main-product__blocks').forEach(product => {
        setupSubscriptions(product);
        if (productObservers.has(product)) return;
        const observer = new MutationObserver(() => setupSubscriptions(product));
        observer.observe(product, { childList: true, subtree: true });
        productObservers.set(product, observer);
      });
    }

    document.addEventListener('click', event => {
      if (!event.target.closest('#neurd-final-buy, .scroll-atc')) return;
      const target = document.querySelector('.main-product__blocks .appstle_widget_title, .main-product__add-to-cart');
      if (!target) return;
      target.tabIndex = -1;
      target.focus({ preventScroll: true });
      const header = document.querySelector('#nav-wrapper');
      const top = target.getBoundingClientRect().top + window.scrollY - (header?.getBoundingClientRect().height || 0) - 20;
      window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });

    let removedItem;
    document.addEventListener('click', event => {
      const button = event.target.closest('.cart-item__remove');
      if (button) removedItem = { item: button.closest('.cart-item'), drawer: button.closest('drawer-component') };
    }, true);
    document.addEventListener('cart:updated', () => {
      if (!removedItem || removedItem.item?.isConnected) return;
      const root = removedItem.drawer?.classList.contains('open') ? removedItem.drawer : document.querySelector('#main-content');
      const target = root?.querySelector('.cart-item__remove, .mini-cart__close, .main-cart--empty a, .cart--empty a') || root;
      if (document.activeElement === document.body && target) target.focus();
      removedItem = null;
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('.pdp-lightbox').forEach(dialog => dialogs.get(dialog)?.());
      event.target.querySelectorAll('.main-product__blocks').forEach(product => productObservers.get(product)?.disconnect());
      event.target.querySelectorAll('.nav--mobile[data-tooltip]').forEach(panel => menuObservers.get(panel)?.disconnect());
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neurd-offer-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neurd-offer-summary')) {
  customElements.define('neurd-offer-summary', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-offer-data]').textContent);
      this.userChose = false;
      this.defaultApplied = false;
      this.update = () => queueMicrotask(() => this.sync());
      this.onChange = event => { if (event.target.matches('.appstle_sub_widget input, .appstle_sub_widget select')) this.update(); };
      this.onUserChoice = event => { if (event.target.closest && event.target.closest('.appstle_sub_widget')) this.userChose = true; };
      document.addEventListener('change', this.onChange, true);
      document.addEventListener('pointerdown', this.onUserChoice, true);
      document.addEventListener('keydown', this.onUserChoice, true);
      this.events = ['AppstleSubscription:SubscriptionWidget:SellingPlanSelected','AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected','AppstleSubscription:SubscriptionWidget:sellingPlanChanged'];
      this.events.forEach(name => document.addEventListener(name, this.update));
      this.sync();
      this.preferSubscription();
      if (!this.widgetReady()) {
        this.observer = new MutationObserver(() => {
          if (!this.widgetReady()) return;
          this.observer.disconnect();
          clearTimeout(this.timer);
          this.preferSubscription();
          this.sync();
        });
        this.observer.observe(this.closest('.shopify-section') || document.body, {childList:true, subtree:true});
        this.timer = setTimeout(() => {
          if (this.widgetReady()) return;
          this.observer.disconnect();
          this.paint(this.data.oneTime);
        }, 8000);
      }
    }
    widgetReady() {
      return Boolean(document.querySelector('.appstle_sub_widget input[type="radio"]'));
    }
    subscriptionOption() {
      return [...document.querySelectorAll('.appstle_sub_widget .appstle_subscription_wrapper_option')].find(o => o.querySelector('.appstle_subscription_radio_wrapper'));
    }
    badge() {
      const option = this.subscriptionOption();
      if (!option || option.querySelector('.neurd-sub-badge')) return;
      const label = option.querySelector('.appstle_subscription_radio_wrapper label') || option.querySelector('label');
      if (!label) return;
      const badge = document.createElement('span');
      badge.className = 'neurd-sub-badge';
      badge.textContent = 'Most popular · Save 30%';
      label.appendChild(badge);
    }
    preferSubscription() {
      if (this.defaultApplied || this.userChose || !this.widgetReady()) return;
      this.defaultApplied = true;
      const option = this.subscriptionOption();
      if (!option || option.classList.contains('appstle-active-option')) return;
      const control = option.querySelector('.appstle_subscription_radio_wrapper input[type="radio"]') || option.querySelector('.appstle_subscription_radio_wrapper label');
      if (control) { control.click(); this.update(); }
    }
    sync() {
      if (!this.widgetReady()) return;
      this.badge();
      const selected = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
      const form = document.querySelector('.main-product__add-to-cart form[data-type="add-to-cart-form"]');
      const planId = selected ? selected.value : form?.querySelector('[name="selling_plan"]')?.value;
      const offer = this.data.plans[planId] || this.data.oneTime;
      if (selected && form) {
        let plan = form.querySelector('input[name="selling_plan"]');
        if (planId) {
          if (!plan) { plan = document.createElement('input'); plan.type='hidden'; plan.name='selling_plan'; form.appendChild(plan); }
          plan.value=planId;
        } else if (plan) plan.remove();
      }
      this.paint(offer);
      const quantitySection = document.querySelector('.main-product__quantity');
      if (quantitySection) quantitySection.hidden = Boolean(planId);
      if (planId) {
        const quantity = quantitySection?.querySelector('input[name="quantity"]');
        if (quantity && quantity.value !== '1') { quantity.value='1'; quantity.dispatchEvent(new Event('change',{bubbles:true})); }
        const formQuantity = form?.querySelector('input[name="quantity"]');
        if (formQuantity) formQuantity.value='1';
      }
    }
    paint(offer) {
      this.querySelector('[data-offer-price]').textContent = offer.price;
      this.querySelector('[data-offer-description]').textContent = offer.description;
      this.querySelector('[data-offer-serving]').textContent = offer.serving;
      const from = this.querySelector('[data-offer-from]');
      if (from && offer.from) from.textContent = offer.from;
      const night = this.querySelector('[data-offer-night]');
      if (night) night.textContent = offer.serving;
      const renewal = this.querySelector('[data-offer-renewal]');
      renewal.hidden = !offer.renewal;
      renewal.textContent = offer.renewal ? `${offer.renewal}. ${offer.name}.` : '';
    }
    disconnectedCallback() {
      document.removeEventListener('change',this.onChange,true);
      document.removeEventListener('pointerdown',this.onUserChoice,true);
      document.removeEventListener('keydown',this.onUserChoice,true);
      this.events.forEach(name => document.removeEventListener(name,this.update));
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
